import React from 'react';
import { Card, Typography } from 'antd';
import { useAuthStore, businessUnitLabel } from '@/store/authStore';

const { Title, Paragraph, Text } = Typography;

function roleList(roles: string[]): string {
  const names = roles.map((role) => role.trim()).filter(Boolean);
  return names.length > 0 ? names.join(', ') : '—';
}

const ProfilePage: React.FC = () => {
  const { user, authorization, currentBusinessUnit } = useAuthStore();
  const units = authorization?.units ?? [];

  return (
    <div style={{ padding: 24 }}>
      <Title level={2} style={{ marginBottom: 0 }}>Profile</Title>
      <Paragraph type="secondary" style={{ marginTop: 8, maxWidth: 720 }}>
        Your sign-in identity and the access assigned to you.
      </Paragraph>
      <Card style={{ maxWidth: 720 }}>
        <Paragraph style={{ marginBottom: 8 }}>
          <Text type="secondary">Name</Text>
          <br />
          <Text>{user?.displayName?.trim() || '—'}</Text>
        </Paragraph>
        <Paragraph style={{ marginBottom: 16 }}>
          <Text type="secondary">Email</Text>
          <br />
          <Text>{user?.email?.trim() || '—'}</Text>
        </Paragraph>

        <Title level={4} style={{ marginTop: 0 }}>Access</Title>
        {!authorization ? (
          <Paragraph type="secondary" style={{ marginBottom: 16 }}>
            Access details are unavailable.
          </Paragraph>
        ) : (
          <div style={{ marginBottom: 16 }}>
            {authorization.globalAdmin && (
              <Paragraph style={{ marginBottom: 8 }}>Admin (all business units)</Paragraph>
            )}
            {units.map((unit) => (
              <Paragraph key={unit.id} style={{ marginBottom: 8 }}>
                {businessUnitLabel(unit.id)} — {roleList(unit.roles)}
              </Paragraph>
            ))}
            {!authorization.globalAdmin && units.length === 0 && (
              <Paragraph type="secondary" style={{ marginBottom: 0 }}>
                No business-unit roles are assigned.
              </Paragraph>
            )}
          </div>
        )}

        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          Currently viewing: {currentBusinessUnit?.name || 'None selected'} (view filter)
        </Paragraph>
      </Card>
    </div>
  );
};

export default ProfilePage;
